var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"statusModule":"ipv6_gateway","resource":"ipv6_gateways","base-info":_vm.baseInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }